import React from 'react';

interface PdfViewerContentProps {
  children: React.ReactNode;
  isLoading: boolean;
  error: string | null;
}

export function PdfViewerContent({ children, isLoading, error }: PdfViewerContentProps) {
  return (
    <div
      className="flex-1 bg-gray-100 overflow-y-scroll pdf-container"
      style={{ scrollBehavior: 'smooth' }}
    >
      {isLoading ? (
        <div className="flex flex-col items-center justify-center p-12">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
          <p className="text-muted-foreground mt-4" aria-live="polite">Loading PDF document...</p>
        </div>
      ) : error ? (
        <div
          className="flex flex-col items-center justify-center p-12"
          role="alert"
          aria-live="assertive"
        >
          <div className="text-destructive text-center">
            <p className="font-medium text-lg mb-2">Error Loading PDF</p>
            <p className="mb-4">{error}</p>
          </div>
          <div className="text-sm text-muted-foreground">
            <p>Try refreshing the page or downloading the PDF directly.</p>
          </div>
        </div>
      ) : (
        <div className="pdf-content-container min-h-full">
          {children}
        </div>
      )}
    </div>
  );
}
